

























import Vue, { PropType } from 'vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import { navigatePush } from '@/features/navigation/navigationMethods'
import { $editedGroupId } from '@/pages/users/groups/create/model/edit-group.model'

export default Vue.extend({
  name: 'CreateGroupFooter',
  components: {
    BaseButton,
  },
  props: {
    disabled: { type: Boolean as PropType<boolean>, default: true },
  },
  effector: {
    groupId: $editedGroupId,
  },
  methods: {
    goToList() {
      switch (this.$route.name) {
        default:
          navigatePush({ name: 'groups-list' })
      }
    },
    onSaveClick() {
      this.$emit('save')
    },
    onSaveAndBackClick() {
      this.$emit('saveAndBackToList')
    },
  },
})
